import React from 'react';

import Kit from './Kit.jsx';
import Layout from '../common/Layout.jsx';
import PageType from '../common/PageType.jsx';
import Utilities from '../common/Utilities.jsx';

const StyleGuide = {
    configureDefaultColors: (config, defaultColors) => {
        if (!config || !defaultColors) {
            return;
        }
        const colors = config.colors || {};
        if (!colors.navBackground) {
            colors.navBackground = defaultColors.navBackground;
        }
        if (!colors.navText) {
            colors.navText = defaultColors.navText;
        }
        if (!colors.accent) {
            colors.accent = defaultColors.accent;
        }
        if (!colors.bodyBackground) {
            colors.bodyBackground = defaultColors.bodyBackground;
        }
        if (!colors.bodyHeaderText) {
            colors.bodyHeaderText = defaultColors.bodyHeaderText;
        }
        if (!colors.bodyText) {
            colors.bodyText = defaultColors.bodyText;
        }
        if (!colors.footerBackground) {
            colors.footerBackground = defaultColors.footerBackground;
        }
        if (!colors.footerHeaderText) {
            colors.footerHeaderText = defaultColors.footerHeaderText;
        }
        if (!colors.footerText) {
            colors.footerText = defaultColors.footerText;
        }
        config.colors = colors;
    },
    getDefaultColors: (layout, colors) => {
        const defaultColors = StyleGuide.getLayoutDefaultColors(layout);
        const config = { colors: colors };
        StyleGuide.configureDefaultColors(config, defaultColors);

        const colorsList = [];
        for (let id in config.colors) {
            const colorObj = { color: config.colors[id], type: id };
            switch (id) {
                case 'accent':
                    colorObj.label = 'Accent';
                    break;
                case 'bodyBackground':
                    colorObj.label = 'Body Background';
                    break;
                case 'bodyHeaderText':
                    colorObj.label = 'Body Header Text';
                    break;
                case 'bodyText':
                    colorObj.label = 'Body Text';
                    break;
                case 'footerBackground':
                    colorObj.label = 'Footer Background';
                    break;
                case 'footerHeaderText':
                    colorObj.label = 'Footer Header Text';
                    break;
                case 'footerText':
                    colorObj.label = 'Footer Text';
                    break;
                case 'navBackground':
                    colorObj.label = 'Navigation Background';
                    break;
                case 'navText':
                    colorObj.label = 'Navigation Text';
                    break;
            }
            colorsList.push(colorObj);
        }
        return colorsList;
    },
    getDefaultColorsList: (layout, colors) => {
        const defaultColors = StyleGuide.getLayoutDefaultColors(layout);
        const config = { colors: colors };
        StyleGuide.configureDefaultColors(config, defaultColors);
        let colorList = [];
        for (let id in config.colors) {
            colorList.push(config.colors[id]);
        }
        return colorList;
    },
    getLayoutDefaultColors: (layout) => {
        switch (layout) {
            case Layout.Type.Theme.Arizona:
                return {
                    navBackground: "rgba(255,255,255,1)",
                    navText: "rgba(84,84,84,1)",
                    accent: "#02aee5",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#696969",
                    bodyText: "#6e6e6e",
                    footerBackground: "#252525",
                    footerHeaderText: "rgba(255,255,255,1)",
                    footerText: "rgba(255,255,255,1)"
                };
            case Layout.Type.Theme.Classic:
                return {
                    navBackground: "#363636",
                    navText: "rgba(255,255,255,1)",
                    accent: "rgba(255,255,255,1)",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#696969",
                    bodyText: "#6e6e6e",
                    footerBackground: "#252525",
                    footerHeaderText: "rgba(255,255,255,1)",
                    footerText: "rgba(255,255,255,1)"
                };
            case Layout.Type.Theme.Francisco:
                return {
                    navBackground: "rgba(255,255,255,1)",
                    navText: "#383832",
                    accent: "#d48235",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#383832",
                    bodyText: "#383832",
                    footerBackground: "rgba(255,255,255,1)",
                    footerHeaderText: "#8f8f8f",
                    footerText: "#383832"
                };
            case Layout.Type.Theme.Mariana:
                return {
                    navBackground: "rgba(255,255,255,1)",
                    navText: "#323232",
                    accent: "#02aee5",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#696969",
                    bodyText: "#7d7d7d",
                    footerBackground: "#757575",
                    footerHeaderText: "rgba(255,255,255,1)",
                    footerText: "rgba(255,255,255,1)"
                };
            case Layout.Type.Theme.Nashville:
                return {
                    navBackground: "rgba(255,255,255,1)",
                    navText: "#434343",
                    accent: "#aaaaaa",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#656565",
                    bodyText: "#696969",
                    footerBackground: "#323232",
                    footerHeaderText: "rgba(255,255,255,1)",
                    footerText: "rgba(255,255,255,1)"
                };
            case Layout.Type.Theme.Novara:
                return {
                    navBackground: "rgba(255,255,255,1)",
                    navText: "#434343",
                    accent: "#aaaaaa",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#656565",
                    bodyText: "#696969",
                    footerBackground: "#323232",
                    footerHeaderText: "rgba(255,255,255,1)",
                    footerText: "rgba(255,255,255,1)"
                };
            case Layout.Type.Theme.Piedmont:
                return {
                    navBackground: "#363636",
                    navText: "rgba(255,255,255,1)",
                    accent: "#62d8fd",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#204030",
                    bodyText: "#505050",
                    footerBackground: "rgba(255,255,255,1)",
                    footerHeaderText: "#656565",
                    footerText: "#656565"
                };
            case Layout.Type.Theme.Sydney:
                return {
                    navBackground: "#363636",
                    navText: "rgba(255,255,255,1)",
                    accent: "#51d4fd",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "#696969",
                    bodyText: "#333333",
                    footerBackground: "#252525",
                    footerHeaderText: "#bebebe",
                    footerText: "#bebebe"
                };
            default:
                return {
                    navBackground: "rgba(255,255,255,1)",
                    navText: "#666666",
                    accent: "#00b1ff",
                    bodyBackground: "rgba(255,255,255,1)",
                    bodyHeaderText: "rgba(0,0,0,1)",
                    bodyText: "#333333",
                    footerBackground: "rgba(0,0,0,1)",
                    footerHeaderText: "rgba(255,255,255,1)",
                    footerText: "#cccccc"
                }
        }
    }
};

function LegacyThemeStyle(props) {
    const config = props.config || {};
    let layout = config.layout;
    let layoutClassSelector = '';
    if (layout) {
        layout = layout.toLowerCase();
        layoutClassSelector = `.${layout}`;

        const defaultColors = StyleGuide.getLayoutDefaultColors();
        StyleGuide.configureDefaultColors(config, defaultColors);
    }

    const colors = config.colors || {};
    const fonts = Layout.Font.typedStrings(config);
    const bodyFont = fonts.body || '';
    const headerFont = fonts.header || '';
    let defaults;
    if (Layout.isPresentation(props.pageContext)) {
        defaults = ``;
        if (config.documents &&
            config.documents[Kit.Type.Presentation] &&
            config.documents[Kit.Type.Presentation].kit &&
            config.documents[Kit.Type.Presentation].kit[Kit.Type.CustomPage] &&
            config.documents[Kit.Type.Presentation].kit[Kit.Type.CustomPage].page &&
            config.documents[Kit.Type.Presentation].kit[Kit.Type.CustomPage].page.backgroundColor) {
            defaults = `body.tennies, .tennies .ol--aw, .tennies .ol--modal--whitelabel { background-color: ${config.documents[Kit.Type.Presentation].kit[Kit.Type.CustomPage].page.backgroundColor};}`
        }
    } else {
        defaults = `
        /* Fonts */
        .tennies .typ--main,
        .tennies .show__card__title,
        .tennies .show__card__title__sub,
        .tennies .blog__card__title,
        .tennies .cover .typ,
        .tennies .nav__menu,
        .tennies .artist__header__name,
        .tennies .artist__header__details,
        .tennies .slider__sub,
        .tennies .slider__type,
        .tennies .foot_title,
        .tennies .sect--fh__title,
        .tennies .editor__content h1,
        .tennies .editor__content h2,
        .tennies .editor__content h3,
        .tennies .editor__content h4,
        .tennies .editor__content h5,
        .tennies .editor__content h6,
        .tennies .raw-html-embed h1,
        .tennies .raw-html-embed h2,
        .tennies .raw-html-embed h3,
        .tennies .raw-html-embed h4,
        .tennies .raw-html-embed h5,
        .tennies .raw-html-embed h6,
        .tennies .sect--results__result__type,
        .tennies .custom__content h1,
        .tennies .custom__content h2,
        .tennies .custom__content h3,
        .tennies .custom__content h4,
        .tennies .custom__content h5,
        .tennies .custom__content h6,
        .tennies .editor__content .font--header,
        .tennies .raw-html-embed .font--header,
        .tennies h1.bio__name,
        .tennies .francisco .show__meta h2 {
            font-family: ${headerFont} !important;
        }
        body.tennies,
        .tennies .btn:not(.btn--custom2),
        .tennies .input,
        .tennies .editor__content,
        .tennies .raw-html-embed,
        .tennies .custom__content,
        .tennies pre,
        .tennies .editor__content .column,
        .tennies .raw-html-embed .column,
        .tennies .foot--main__text,
        .tennies .editor__content .font--body,
        .tennies .raw-html-embed .font--body,
        .tennies .francisco .show__card__title,
        .tennies .francisco .blog__card__title,
        .tennies .francisco .aw__item__details .artwork__artist,
        .tennies .aw__item__details .artwork__info__item,
        .tennies .francisco .tabs__content .cont--blog .col:first-child .news__title{
            font-family: ${bodyFont};
        }
        .tennies p > span,
        .tennies .artist__content--more,
        .tennies .artwork__artist,
        .tennies .artwork__title,
        .tennies .artwork__info__item,
        .tennies .block__cont p,
        .tennies .btn--inquire,
        .tennies .btn--offer,
        .tennies .btn--purchase,
        .tennies .cont--token p > span,
        .tennies .filters__chip__cont,
        .tennies .filters__cont .col > div,
        .tennies .richText p > span,
        .tennies .tabs__controls li {
            font-family: ${bodyFont};
        }
        .tennies .cont--token p > span {
            font-family: inherit;
        }
        /* Nav */
        .tennies .nav.nav--main,
        .tennies .nav--column,
        .tennies .nav.nav--fixed,
        .tennies .drop__inn__holder,
        .tennies .search--row {
            background-color: ${colors.navBackground};
        }
        .tennies .francisco .drop__inn__holder {
            background-color: transparent;
        }
        .tennies .search--row__btn.btn {
            background-color: ${colors.navText};
            color: ${colors.navBackground};
        }
        .tennies .drop__inn__holder:after {
            border-bottom-color: ${colors.navBackground};
        }
        .tennies .nav--main .nav__menu__anch,
        .tennies .nav--whitelabel .nav__menu__anch,
        .tennies .nav__menu .drop__anch,
        .tennies .drop__inn,
        .tennies .nav__menu__anch,
        .tennies .nav--main .nav__menu__anch .drop__anch,
        .tennies .nav--whitelabel .nav__menu__anch .drop__anch,
        .tennies .search__holder a,
        .tennies .cart__holder,
        .tennies .search--row__field {
            color: ${colors.navText};
        }
        .tennies .search--row__field::placeholder {
            color: ${colors.navText};
        }
        .tennies .search--row__field::-webkit-input-placeholder {
            color: ${colors.navText};
        }
        .tennies .search--row__field::-moz-placeholder {
            color: ${colors.navText};
        }
        .tennies .search--row__field:-ms-input-placeholder {
            color: ${colors.navText};
        }
        .tennies .search--row__field:-moz-placeholder {
            color: ${colors.navText};
        }
        .tennies .search--row__field {
            border-bottom-color: ${colors.navText};
        }
        .tennies .nav__menu__anch:hover,
        .tennies .francisco .nav__menu__anch .drop__anch:hover,
        .tennies .francisco .drop--active .drop__anch,
        .tennies .francisco .drop--active .drop__inn__anch:hover {
            color: ${colors.accent};
        }
        .tennies .nav__menu__anch.nav__menu__anch--active,
        .tennies .drop__anch--active,
        .tennies .drop__inn__anch--active,
        .tennies .nav--whitelabel .nav__menu__anch .drop__inn__anch--active {
            color: ${colors.accent};
        }
        .tennies .francisco .nav__menu {
            font-family: ${bodyFont} !important;
        }
        .tennies .control__holder {
            color: ${colors.navText};
        }
        /* Footer */
        .tennies .foot--main,
        .tennies .foot--simp,
        .tennies .foot--main .input {
            background-color: ${colors.footerBackground};
        }
        .tennies .arizona .foot--simp__inn,
        .tennies .classic .foot--simp__inn, 
        .tennies .sydney .foot--simp__inn,
        .tennies .novara .foot--simp__inn,
        .tennies .francisco .foot--simp__inn,
        .tennies .mariana .foot--simp__inn {
            border-color: ${colors.footerHeaderText};
        }
        .tennies .foot__title {
            color: ${colors.footerHeaderText};
        }
        .tennies .foot__title:after {
            background-color: ${colors.footerText};
        }
        .tennies .foot--main__text,
        .tennies .foot--simp__text,
        .tennies .foot--main__anch,
        .tennies .foot--main .social__anch,
        .tennies .foot--simp .social__anch,
        .tennies .foot--whitelabel .social__anch,
        .tennies .foot--whitelabel--copyright,
        .tennies .form--sub .input input,
        .tennies .foot__copy {
            color: ${colors.footerText};
        }
        .tennies .form--sub .input input::placeholder {
            color: ${colors.footerText};
        }
        .tennies .form--sub .input input::-webkit-input-placeholder {
            color: ${colors.footerText};
        }
        .tennies .form--sub .input input::-moz-placeholder {
            color: ${colors.footerText};
        }
        .tennies .form--sub .input input:-ms-input-placeholder {
            color: ${colors.footerText};
        }
        .tennies .form--sub .input input:-moz-placeholder {
            color: ${colors.footerText};
        }
        .tennies .francisco .foot--main__anch,
        .tennies .francisco .foot--main .social__anch,
        .tennies .francisco .foot--simp .social__anch,
        .tennies .francisco a.foot--main__text,
        .tennies .francisco .foot--main__text a,
        .tennies .francisco .foot--main__anch a {
            color: ${colors.accent};
        }
        .tennies .foot--whitelabel .input >input,
        .tennies .foot--main .input >input {
            border-color: ${colors.footerText};
        }
        .tennies .form--sub .input input::-moz-placeholder {
            color: ${colors.footerText};
        }
        .tennies .form--sub .input input:-ms-input-placeholder {
            color: ${colors.footerText};
        }
        .tennies .form--sub .input input:-moz-placeholder {
            color: ${colors.footerText};
        }
        .tennies .novara .foot--main__row,
        .tennies .francisco .foot--main__row {
            border-color: ${colors.footerText};
        }
        .tennies .novara .form--sub .input--outl >input:focus,
        .tennies .francisco .form--sub .input--outl >input:focus {
            color: ${colors.footerText};
        }
        .tennies .form--sub button {
            background-color: transparent;
            border-color: ${colors.accent};
            color: ${colors.accent};
        }
        .tennies .form--sub button:hover {
            background-color: ${colors.accent};
            border-color: ${colors.accent};
            color: ${colors.footerBackground};
        }
        .tennies .form--sub button.btn--success:hover,
        .tennies .form--sub button.btn--processing:hover {
            background-color: inherit;
            border-color: ${colors.accent};
            color: ${colors.accent};
        }
        /* Body */
        .tennies .sect,
        .tennies .drop--aw,
        .tennies .mariana .nav,
        .tennies .ol--aw,
        .tennies .artwork__outer,
        .tennies .custom__content,
        .tennies .ol--share__modal--inquire,
        .tennies .ol--share__modal,
        .tennies .ol--offer__modal,
        .tennies .ol--purchase__modal {
            background-color: ${colors.bodyBackground};
            background-image: none;
            color: ${colors.bodyText};
        }
        .tennies ${layoutClassSelector} {
            background-color: transparent;
            background-image: none;
            color: ${colors.bodyText};
        }
        body.tennies {
            background-color: ${colors.bodyBackground};
        }
        .tennies .show__card__date,
        .tennies .aw__item__name,
        .tennies .aw__item__user,
        .tennies .drop--aw__artist,
        .tennies .ol--aw__artist,
        .tennies .ol--share__inn .i--dark,
        .tennies .ol--share__inn .i,
        .tennies .ol--purchase__inn .i--dark,
        .tennies .ol--purchase__inn .i,
        .tennies .drop--aw__meta__foot,
        .tennies .ol--aw__meta__foot,
        .tennies .drop--aw__meta__foot >a,
        .tennies .ol--aw__meta__foot >a,
        .tennies .sect--contact__info,
        .tennies .input--outl >input,
        .tennies .input--area textarea,
        .tennies .artwork__artist,
        .tennies .classic .artwork__artist,
        .tennies .artwork__controls a,
        .tennies .form--payment__container .typ--main__inn,
        .tennies .ol__next .i,
        .tennies .ol__prev .i,
        .tennies .ol__arrow,
        .tennies .artist__card__name,
        .tennies .artist__list__name,
        .tennies .artist__preview__name,
        .tennies .artwork__notes,
        .tennies .artwork__title,
        .tennies .artwork__info__item,
        .tennies .slider--multi-item .slider__slide a .sect--slider__caption,
        .tennies .editor__content .tabs__controls li.current span,
        .tennies .francisco .editor__content .tabs__controls li span,
        .tennies .tabs__controls li.current span, 
        .tennies .francisco .tabs__controls li span,
        .tennies .francisco .artwork__info__item__date,
        .tennies .francisco .news__title--link {
            color: ${colors.bodyText};
        }
        .tennies a,
        .tennies a:active,
        .tennies .editor__content .tabs__controls li span, 
        .tennies .francisco .editor__content .tabs__controls li.current span,
        .tennies .tabs__controls li span,
        .tennies .francisco .tabs__controls li.current span,
        .tennies .francisco .artist__content--more a {
            color: ${colors.accent};
        }
        .tennies h1.typ--main,
        .tennies ${layoutClassSelector} h2,
        .tennies .show__card__title,
        .tennies .blog__card__title  {
            color: ${colors.bodyHeaderText};
        }
        .tennies .typ--main__inn:before,
        .tennies .typ--main--modal .typ--main__inn:before, 
        .tennies .editor__content .typ--main--modal .typ--main__inn:before {
            background-color: ${colors.bodyHeaderText};
        }
        /* Forms */
        .tennies .input--outl >input,
        .tennies .input--outl >textarea {
            border-color: ${colors.bodyText};
        }
        .tennies .input--outl >input:focus {
            border-color: ${colors.accent};
        }
        .tennies .input--outl >input::placeholder,
        .tennies .ol--share__close,
        .tennies .ol--purchase__close,
        .tennies .ol--offer__close,
        .tennies .ol--share__back,
        .tennies .ol--purchase__back,
        .tennies .ol--offer__back,
        .tennies .ol__cont a.btn--outl,
        .tennies .ol__cont button.btn--outl {
            color: ${colors.bodyText};
            fill: ${colors.bodyText};
        }
        .tennies .input--outl >input::-webkit-input-placeholder {
            color: ${colors.bodyText};
        }
        .tennies .input--outl >input::-moz-placeholder{
            color: ${colors.bodyText};
        }
        .tennies .input--outl >input:-ms-input-placeholder{
            color: ${colors.bodyText};
        }
        .tennies .input--outl >input:-moz-placeholder{
            color: ${colors.bodyText};
        }
        .tennies .input--area textarea::placeholder{
            color: ${colors.bodyText};
        }
        .tennies .input--area textarea::-webkit-input-placeholder{
            color: ${colors.bodyText};
        }
        .tennies .input--area textarea::-moz-placeholder{
            color: ${colors.bodyText};
        }
        .tennies .input--area textarea:-ms-input-placeholder{
            color: ${colors.bodyText};
        }
        .tennies .input--area textarea:-moz-placeholder {
            color: ${colors.bodyText};
        }
        .tennies .input--area textarea {
            background-color: transparent;
        }
        .tennies .input--area.input--outl {
            border-color: ${colors.bodyText};
        }
        .tennies .select,
        .tennies .multiselect,
        .tennies .multiselect__options {
            border-color: ${colors.bodyText};
            background-color: ${colors.bodyBackground};
            color: ${colors.bodyText}
        }
        /* Theme Specific */
        .tennies .classic .typ--main__inn,
        .tennies .classic .artwork__side .typ--main .typ--main__inn,
        .tennies .classic .sect--info h1 * {
            background-color: ${colors.bodyBackground};
        }
        .tennies .classic .show__card {
            border-color: ${colors.bodyText};
        }
        .tennies .sydney .drop__inn {
            border-color: ${colors.accent};
        }
        .tennies .mariana .show__card__title,
        .tennies .mariana .blog__card__title {
            font-family: ${bodyFont} !important;
        }
        /* Buttons */
        .tennies .editor__content .btn--outl,
        .tennies .raw-html-embed .btn--outl,
        .tennies .btn--outline {
            border-color: ${colors.bodyText};
            background-color: transparent;
            color: ${colors.bodyText};
        }
        .tennies .btn--prim.btn--outl {
            border-color: ${colors.accent};
            background-color: transparent;
            color: ${colors.accent};
        }
        .tennies .btn--fill {
            background-color: ${colors.bodyText};
            border-color: ${colors.bodyText};
            color: ${colors.bodyBackground};
        }
        .tennies .btn--fill:focus,
        .tennies .btn--fill:hover,
        .tennies .btn--outl:focus,
        .tennies .btn--outl:hover,
        .tennies .btn--prim.btn--outl:focus,
        .tennies .btn--prim.btn--outl:hover {
            background-color: ${colors.accent};
            border-color: ${colors.accent};
            color: ${colors.bodyBackground};
        }
        .tennies .btn--success,
        .tennies .editor__content .btn--success,
        .tennies .raw-html-embed .btn--success {
            color: ${colors.accent};
            font-weight: bold;
        }
        .tennies .btn--processing:hover,
        .tennies .btn--success:hover {
            background-color: inherit;
            border-color: inherit;
            color: inherit;
        }
        .tennies .btn--processing .submission-status:after {
            border-color: ${colors.accent} ${colors.accent} ${colors.accent} transparent;
        }
        .tennies .btn--success .submission-status:after {
            border-color: transparent ${colors.accent} ${colors.accent} transparent;
        }
        .tennies .editor__content a,
        .tennies .raw-html-embed a,
        .tennies .artwork__controls a:hover,
        .tennies .description a,
        .tennies .custom__content a {
            color: ${colors.accent};
        }
        /* Slider */
        .tennies .editor__content .slider--fit .owl-dot {
            background-color: ${colors.bodyText};
        }
        .tennies .editor__content .slider--fit .owl-nav {
            color: ${colors.bodyText};
        }
        /* Shopping Cart */
        .tennies .shopping-cart__table {
            border-color: ${colors.bodyText}
        }
        .tennies .shopping-cart__table__close {
            color: ${colors.bodyText}
        }
        /* Helpers */
        .tennies .nav-bkg {
            background-color: ${colors.navBackground} !important;
        }
        .tennies .nav-txt {
            background-color: ${colors.navText} !important;
        }
        .tennies .foot-bkg {
            background-color: ${colors.footerBackground} !important;
        }
        .tennies .foot-txt {
            color: ${colors.footerText} !important;
        }
        .tennies .foot-head-txt {
            color: ${colors.footerHeaderText} !important;
        }
        .tennies .piedmont .cont--whitelabel h1:before {
            background-color: ${colors.bodyHeaderText};
        }
    `;
    }
    return (
        <React.Fragment>
            <style dangerouslySetInnerHTML={{ __html: defaults }}></style>
            {
                config.style &&
                config.style.length > 0 &&
                <style dangerouslySetInnerHTML={{ __html: config.style }}></style>
            }
        </React.Fragment>
    );
}

function WhiteLabelStyle(props) {
    const config = props.config || {};
    const defaultColors = StyleGuide.getLayoutDefaultColors('whitelabel');
    StyleGuide.configureDefaultColors(config, defaultColors);
    const colors = config.colors || {};
    let html = `
.tennies .nav.nav--whitelabel { background-color:${colors.navBackground}; } 
.tennies .nav .nav--skip__link:after { border-color:${colors.accent}; } 
.tennies .foot--whitelabel, .tennies .foot--whitelabel--droparea, .tennies .foot--whitelabel--copyright--desktop, .tennies .foot--whitelabel--copyright--mobile { background-color:${colors.footerBackground};color:${colors.footerText}; } 
.tennies .cont--social .cell--social a { color:${colors.bodyText}; } 
.tennies .nav--whitelabel .cell--social a { color:${colors.navText}; } 
.tennies .foot--whitelabel .cell--social a { color:${colors.footerText}; }
.tennies .cont--token .custom-color a { color:inherit;}
.tennies .cont__cookies >div { background-color:${colors.bodyBackground}; }`
    return <style dangerouslySetInnerHTML={{ __html: html }}></style>
}

function DesignKit(props) {
    const config = props.config || {};
    const defaultColors = StyleGuide.getLayoutDefaultColors('whitelabel');
    StyleGuide.configureDefaultColors(config, defaultColors);
    const colors = config.colors || {};
    const isPresentation = Layout.isPresentation(props.pageContext)
    let kit = isPresentation ? Kit.presentationKit(config, Kit.Type.Global) : Kit.kit(config, Kit.Type.Global);
    if (!kit) {
        kit = {};
        for (let id in Kit.Context.Global) {
            kit[Kit.Context.Global[id]] = {};
        }
    }

    const createElementStyleString = (elementType, elementStyle, container = '') => `.tennies ${container}.cont--token .${elementType} > span, 
.tennies ${container}.cont--token [data-heading="${elementType}"], 
.tennies ${container}.richText .${elementType} > span, 
.tennies ${container}.richText [data-heading="${elementType}"], 
.tennies ${container}.btn--whitelabel.richText .${elementType} > span, 
.tennies ${container}.btn--whitelabel.richText [data-heading="${elementType}"], 
.tennies ${container}.cont--whitelabel 
.cont--token .${elementType}:not(.layout__page__header):not(.is-title-lite) > span, 
.tennies ${container}.richText input.${elementType}, 
.tennies ${container}.richText textarea.${elementType} { ${elementStyle}}\n`
    let html = '';
    let defaultColor, elementKit, elementStyle;
    for (let elementType in kit) {
        elementKit = kit[elementType];
        elementStyle = '';

        let addAdditionalStyles = false;
        switch (elementType) {
            case Kit.Context.Global.Paragraph:
                defaultColor = { body: colors.bodyText, footer: colors.footerText, navigation: colors.navText };
                addAdditionalStyles = true;
                break;
            default:
                defaultColor = { body: colors.bodyHeaderText, footer: colors.footerHeaderText, navigation: colors.accent };
                break;
        }
        let parentStyle;
        for (let kitProp in elementKit) {
            let extras, key;
            switch (kitProp) {
                case 'design':
                    let value = elementKit[kitProp];
                    if (!value || !value.indexOf) {
                        continue;
                    }
                    let testString = `<p class="${elementType}" style="`;
                    let index = value.indexOf(testString);
                    if (index >= 0) {
                        // Parent style (e.g. text align)
                        let _value = value.substring(index + testString.length);
                        testString = '"';
                        index = _value.indexOf(testString);
                        if (index >= 0) {
                            parentStyle = _value.substring(0, index)
                        }
                    }
                    const extractedStyle = Utilities.extractStyle(value);
                    if (extractedStyle) {
                        elementStyle += extractedStyle;
                    }
                    break;
                case 'marginBottom':
                    extras = 'display:inline-block;';
                    key = 'margin-bottom';
                // Intentional fallthrough
                case 'marginLeft':
                    key = key || 'margin-left';
                // Intentional fallthrough
                case 'marginRight':
                    key = key || 'margin-right';
                // Intentional fallthrough
                case 'marginTop':
                    key = key || 'margin-top';
                // Intentional fallthrough
                // case 'paddingBottom':
                //     key = 'padding-bottom';
                // // Intentional fallthrough
                // case 'paddingLeft':
                //     key = key || 'padding-left';
                // // Intentional fallthrough
                // case 'paddingRight':
                //     key = key || 'padding-right';
                // // Intentional fallthrough
                // case 'paddingTop':
                //     key = key || 'padding-top';
                // // Intentional fallthrough
                default:
                    if (!key || !elementKit[kitProp]) {
                        continue;
                    }
                    if (elementKit[kitProp].value && elementKit[kitProp].unit) {
                        elementStyle += `${key}:${elementKit[kitProp].value}${elementKit[kitProp].unit}; `
                    } else {
                        elementStyle += `${key}:${elementKit[kitProp]}; `;
                    }
                    if (extras) {
                        elementStyle += extras;
                    }
                    break;
            }
        }
        let useKitColor = false;
        const colorlessStyle = elementStyle;
        if (!isPresentation && !elementStyle.startsWith('color:') && elementStyle.indexOf(';color:') < 0) {
            elementStyle += `color:${defaultColor.body};`
            useKitColor = true;
        }
        if (props.onStyle) {
            html += `${props.onStyle(elementType, { element: elementStyle, parent: parentStyle }, useKitColor)}\n`
        } else {
            if (parentStyle) {
                html += `.tennies .cont--token .${elementType}, .tennies .cont--token .${elementType}, .tennies .richText .${elementType} { ${parentStyle} }\n`
            }
            html += createElementStyleString(elementType, elementStyle);
            html += `.tennies .richText .p > [data-heading="${elementType}"], .tennies .btn--select.${elementType} { ${elementStyle}}`
            if (useKitColor) {
                html += `${createElementStyleString(elementType, `color:${defaultColor.footer};`, '.foot--whitelabel ')}${createElementStyleString(elementType, `color:${defaultColor.navigation};`, '.nav--whitelabel ')}`;
                if (props.builder) {
                    html += `${createElementStyleString(elementType, `color:${defaultColor.footer};`, `.context--${PageType.Footer} `)}${createElementStyleString(elementType, `color:${defaultColor.navigation};`, `.context--${PageType.Header} `)}`;
                }
            }
        }
        html += `.tennies .cont--token a [data-heading="${elementType}"], .tennies .nav--whitelabel .cont--token a [data-heading="${elementType}"], .tennies .foot--whitelabel .cont--token a [data-heading="${elementType}"], .tennies .richText a [data-heading="${elementType}"], .tennies .nav--whitelabel .richText a [data-heading="${elementType}"], .tennies .foot--whitelabel .richText a [data-heading="${elementType}"] { ${colorlessStyle}${colors.accent ? `color:${colors.accent};` : ''} }\n`
        if (addAdditionalStyles) {
            if (isPresentation) {
                html += `.tennies .btn {${elementStyle}} `;
            } else {
                // Apply design kit to forms
                html += `.tennies .btn--whitelabel, .tennies .input--whitelabel input { border-color:${defaultColor.body}; } 
.tennies .btn--whitelabel:not(.btn--form--popup) p span, .tennies .input--whitelabel input, .tennies .input--whitelabel .input__placeholder { ${elementStyle} } 
.tennies .btn--whitelabel:not(.btn--form--popup):not(.btn--select):focus, .tennies .btn--whitelabel:not(.btn--form--popup):not(.btn--select):hover, .tennies .btn--whitelabel.btn--hover:not(.btn--form--popup):not(.btn--select) { background-color:${defaultColor.body}; } 
.tennies .btn--whitelabel.richText:not(.btn--form--popup):focus p span, .tennies .btn--whitelabel.richText:not(.btn--form--popup):hover p span, .tennies .btn--whitelabel.richText.btn--hover:not(.btn--form--popup) p span { color:${colors.bodyBackground}; } 
.tennies .nav--whitelabel .btn--whitelabel:not(.btn--form--popup), .tennies .search--whitelabel:not(.btn--form--popup) .btn--whitelabel:not(.btn--form--popup) { border-color:${defaultColor.navigation};${colorlessStyle}color:${defaultColor.navigation}; } 
.tennies .nav--whitelabel .btn--whitelabel:not(.btn--form--popup):focus, .tennies .nav--whitelabel .btn--whitelabel:not(.btn--form--popup):hover, .tennies .nav--whitelabel .btn--whitelabel.btn--hover:not(.btn--form--popup) { background-color:${defaultColor.navigation}; } 
.tennies .nav--whitelabel .btn--whitelabel.richText:not(.btn--form--popup):focus p span, .tennies .nav--whitelabel .btn--whitelabel.richText:not(.btn--form--popup):hover p span, .tennies .nav--whitelabel .btn--whitelabel.richText.btn--hover:not(.btn--form--popup) p span { color:${colors.navBackground}; } 
.tennies .foot--whitelabel .btn--whitelabel, .tennies .foot--whitelabel .input--whitelabel input { border-color:${defaultColor.footer}; } 
.tennies .foot--whitelabel .btn--whitelabel:focus, .tennies .foot--whitelabel .btn--whitelabel:hover, .tennies .foot--whitelabel .btn--whitelabel.btn--hover { background-color:${defaultColor.footer}; } 
.tennies .foot--whitelabel .btn--whitelabel.richText:focus p span, .tennies .foot--whitelabel .btn--whitelabel.richText:hover p span, .tennies .foot--whitelabel .btn--whitelabel.richText.btn--hover p span { color:${colors.footerBackground}; } 
.tennies .foot--whitelabel .btn--whitelabel, .tennies .foot--whitelabel .input--whitelabel input, .tennies .foot--whitelabel .input--whitelabel .input__placeholder { ${colorlessStyle}color:${defaultColor.footer}; }\n
.tennies button.btn:not(.btn--whitelabel):not(.form__btn):not(.richText) { ${elementStyle}color:${colors.bodyBackground}; } 
.tennies .foot--whitelabel button.btn:not(.btn--whitelabel):not(.form__btn) { ${elementStyle}color:${colors.footerBackground}; } 
.tennies .foot--whitelabel button.btn:not(.btn--whitelabel):not(.form__btn):hover { ${elementStyle}color:${colors.footerText}; }\n
.tennies .search--whitelabel, .tennies .search--whitelabel .input--whitelabel { ${elementStyle}border-color:${defaultColor.navigation};color:${defaultColor.navigation}; } 
.tennies .search--whitelabel .btn--whitelabel p span { color:${colors.navText}; } 
.tennies .search--whitelabel .btn--whitelabel:hover, .tennies .search--whitelabel .btn--whitelabel.btn--hover { background-color:${colors.accent};border-color:${colors.accent}; }`
            }
            html += `body.tennies { ${elementStyle} } img { letter-spacing: normal; }\n`;
        }
    }
    if (html.length == 0) {
        return null;
    }
    return <style dangerouslySetInnerHTML={{ __html: html }}></style>
}

export {
    DesignKit,
    LegacyThemeStyle,
    StyleGuide,
    WhiteLabelStyle
};